import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { initialDocSetupState } from "./document-setup.state";
import { DocSetupCurrentPageDetails } from "../../models/document-setup-state.model";

const documentSetupSlice = createSlice({
  name: "documentSetup",
  initialState: initialDocSetupState,
  reducers: {
    setCurrentPageDetails: (
      state,
      { payload }: PayloadAction<DocSetupCurrentPageDetails>
    ) => {
      state.currentPageDetails = payload;
    },
    setHasDuplicate: (state, { payload }: PayloadAction<boolean>) => {
      state.hasDuplicate = payload;
    }
  }
});

export default documentSetupSlice.reducer;
export const documentSetupActions = documentSetupSlice.actions;
